<template>
  <m-box title="Options">
    <div class="m-block">
      <h5>Phone Option</h5>
      <m-phone-option />
    </div>
    <div class="m-block">
      <a @click="$router.push({'name': 'demo-suppression'})">Add suppression</a>
    </div>
  </m-box>
</template>

<script>
  import MBox from '@/components/common/MBox'
  import MPhoneOption from '@/components/demo/MPhoneOption'

  export default {
    components: {
      MBox,
      MPhoneOption
    },
    data () {
      return {}
    },
    computed: {
    },
    methods: {
    }
  }
</script>

<style scoped lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/order2/MOrder2Option.vue